(() => {
  const TRACKED_PARAMETERS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'lp_version',
  ];

  const eventNameFor = (root) => {
    const key = root.dataset.templateKey || '';
    if (key.includes('offer')) return 'dg_lp_offer_add';
    if (key.includes('routine')) return 'dg_lp_routine_select';
    if (key.includes('beard_balm')) return 'dg_lp_balm_add';
    return 'dg_lp_product_select';
  };

  const publish = (root, action, target) => {
    const detail = {
      lp_version: root.dataset.lpVersion || 'ml_2026_07_v1',
      landing_page_id: root.dataset.landingPageId || null,
      template_key: root.dataset.templateKey || null,
      language: root.dataset.language || document.documentElement.lang || null,
      action,
      target: target?.getAttribute('href') || target?.dataset.variantId || null,
    };
    const event = action === 'supporting' ? 'dg_lp_supporting_action' : eventNameFor(root);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
    root.dataset.lpLastEvent = event;
    root.dataset.lpLastAction = action;
    root.dataset.lpLastVersion = detail.lp_version;
    document.dispatchEvent(new CustomEvent(event, { detail }));
  };

  const decorateInternalLinks = (root, currentUrl) => {
    const values = new Map();
    for (const key of TRACKED_PARAMETERS) {
      const value = currentUrl.searchParams.get(key);
      if (value) values.set(key, value);
    }
    if (!values.has('lp_version')) {
      values.set('lp_version', root.dataset.lpVersion || 'ml_2026_07_v1');
    }

    for (const link of root.querySelectorAll('a[href]')) {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) continue;
      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch {
        continue;
      }
      if (url.origin !== window.location.origin) continue;
      for (const [key, value] of values) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      }
      link.href = `${url.pathname}${url.search}${url.hash}`;
    }
  };

  const initialize = () => {
    const currentUrl = new URL(window.location.href);
    const roots = document.querySelectorAll('.paid-landing-page, .routine-gift-landing, .beard-balm-landing');

    for (const root of roots) {
      if (root.dataset.lpAttributionReady === 'true') continue;
      root.dataset.lpAttributionReady = 'true';
      root.dataset.lpVersion = currentUrl.searchParams.get('lp_version') || root.dataset.lpVersion || 'ml_2026_07_v1';
      decorateInternalLinks(root, currentUrl);

      root.addEventListener('click', (event) => {
        const source = event.target instanceof Element ? event.target : event.target?.parentElement;
        const target = source?.closest('[data-lp-action], [data-routine-submit], [data-bb-submit], a[href]');
        if (!target || !root.contains(target)) return;
        const explicitAction = target.dataset.lpAction;
        if (explicitAction) {
          publish(root, explicitAction, target);
          return;
        }
        if (target.matches('[data-routine-submit], [data-bb-submit]')) {
          publish(root, 'primary', target);
          return;
        }
        const href = target.getAttribute('href') || '';
        publish(root, href.startsWith('#') ? 'supporting' : 'product', target);
      }, { capture: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
